module.exports = __webpack_public_path__ + "img/logistic.5fa7f02b.png";